"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTextInput = _interopRequireDefault(require("react-text-input"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propValidators = require("prop-validators");

var _dateUtils = require("./date-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STYLES = {
  errorMessage: {
    WebkitTransition: 'all 0.25s ease-in-out',
    MozTransition: 'all 0.25s ease-in-out',
    msTransition: 'all 0.25s ease-in-out',
    OTransition: 'all 0.25s ease-in-out',
    transition: 'all 0.25s ease-in-out'
  }
};

var Expiry =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Expiry, _React$Component);

  function Expiry() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Expiry);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Expiry)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      value: '',
      showIsRequiredError: false,
      lastCharacterIsSlash: false
      /**
       * Handle changing expiry date
       * Use the getFormattedExpirationDate util to format the date
       * @param {String} date - expiry date
       * @return {String} expiry - the formatted date
       */

    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeDate", function (_ref) {
      var date = _ref.target.value;
      // if the new date is two digits and the previous date ended in a slash, we
      // should not add a slash when we format the date
      var shouldRemoveTrailingSlash = date.length === 2 && _this.state.lastCharacterIsSlash;
      var expiry = (0, _dateUtils.getFormattedExpirationDate)(date, {
        shouldRemoveTrailingSlash: shouldRemoveTrailingSlash
      });

      _this.handleCheckForValue(date);

      _this.props.handleChangeDate(expiry);

      _this.setState({
        lastCharacterIsSlash: expiry.slice(-1) === '/',
        value: expiry
      });

      return expiry;
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckForValue", function (date) {
      var _this$props$cardSpec$ = _this.props.cardSpec.fields.expirationDate.required,
          required = _this$props$cardSpec$ === void 0 ? false : _this$props$cardSpec$;

      _this.setState({
        showIsRequiredError: required && !date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (_ref2) {
      var date = _ref2.target.value;

      _this.props.handleFocus(date);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (_ref3) {
      var date = _ref3.target.value;

      _this.handleCheckForValue(date);

      _this.props.handleBlur(date);
    });

    return _this;
  }

  _createClass(Expiry, [{
    key: "render",
    value: function render() {
      var expirySpecs = this.props.cardSpec.fields.expirationDate;
      var errorMessage = this.props.errorMessage;
      var errorStyles = {
        height: 0,
        padding: 0
      };

      if (errorMessage) {
        errorStyles = {
          height: '100%'
        };
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_has-error-with-message': errorMessage,
          'vx_has-error': !errorMessage && this.state.showIsRequiredError
        }),
        style: {
          margin: '10px 0 0',
          position: 'relative'
        }
      }, _react.default.createElement(_reactTextInput.default, {
        type: "tel",
        id: "expiry",
        value: this.state.value,
        name: "expiry",
        className: "vx_form-control vx_form-control_complex",
        label: this.props.label,
        maxLength: expirySpecs.maxlength,
        pattern: expirySpecs.pattern,
        required: expirySpecs.required,
        helpText: this.props.helpText,
        onChange: this.handleChangeDate,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        dir: this.props.dir
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)({
          'vx_form-control-message': errorMessage
        }),
        style: _objectSpread({}, STYLES.errorMessage, {
          errorStyles: errorStyles
        })
      }, errorMessage));
    }
  }]);

  return Expiry;
}(_react.default.Component);

_defineProperty(Expiry, "defaultProps", {
  handleFocus: function handleFocus() {},
  handleBlur: function handleBlur() {}
});

Expiry.propTypes = process.env.NODE_ENV !== "production" ? {
  cardSpec: _propValidators.cardSpecPropType,
  label: _propTypes.default.string.isRequired,
  helpText: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  handleChangeDate: _propTypes.default.func.isRequired,
  handleFocus: _propTypes.default.func,
  handleBlur: _propTypes.default.func,
  dir: _propTypes.default.string
} : {};
var _default = Expiry;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-expiry-date/dist/index.js
// module id = 1026
// module chunks = 5